// extracted by mini-css-extract-plugin
export default {"wrapper":"TimeIsUp_wrapper__RCO6e","up":"TimeIsUp_up__xmU8W","content":"TimeIsUp_content__NxOHM","buttons":"TimeIsUp_buttons__Vbrev"};